module.exports = __webpack_public_path__ + "img/five-aa.4f22f520.png";